import _ from 'lodash'
import { usercentricsCmp } from '@base-shared/composables/use-usercentrics-cmp'

const CMP_NAME = 'privacy'
const FEEDBACK_FORM = 'feedbackForm'
const LEGAL = 'legal'

export default {
  name: 'helpCenterButton',
  inject: [
    '$utils'
  ],
  mixins: [],
  compatConfig: {
    MODE: 3 // opt-in to Vue 3 behavior for this component only,
  },
  props: {
    isLoggedOut: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      active: false,
      helpLinks: [
        { value: 'helpCenter', sortKey: 1 },
        { value: 'releaseNotes', sortKey: 2 },
        { value: 'keyboardShortcuts', sortKey: 3 },
        { value: FEEDBACK_FORM, sortKey: 6 }
      ],
      isCmpEnabled: !!CONFIG.CMP_SCRIPTS,
      externalLinks: CONFIG.EXTERNAL_LINKS ?? {}
    }
  },
  computed: {
    links () {
      const externalLinkKeys = Object.keys(this.externalLinks)

      // Get what is common between external links (depends on what is available for a stage) to what we want to show as help links.
      const linksAvailable = _.chain(this.helpLinks)
        .filter((link) => externalLinkKeys.includes(link.value))
        .value()

      // Push Legal link
      linksAvailable.push({ value: LEGAL, sortKey: 5 })

      // Push Privacy if Consent Management Platform is enabled
      if (this.isCmpEnabled) {
        linksAvailable.push({ value: CMP_NAME, sortKey: 4 })
      }

      // Perform sort according to given sortKey to arrange the list
      return _.chain(linksAvailable).sortBy(['sortKey']).map('value').value()
    }
  },
  methods: {
    handleButtonClick (linkType) {
      if (linkType === CMP_NAME) {
        usercentricsCmp().toggleDisplay()
      } else if (linkType === LEGAL) {
        this.$router.push('/legal')
      } else {
        if (this.externalLinks[linkType]) {
          window.open(this.externalLinks[linkType])
        }
      }
    }
  }
}
